import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner-form-actions',
  template: `<span class="loading-spiner spinner-form-{{ position }}"></span>`,
})
export class SpinnerFormActionsComponent implements OnInit {
  @Input() position: string = 'left';

  ngOnInit(): void {}
}
